export const toSlug = (text: string) =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

/**
 * 生成锚点ID
 * @param text 文本
 * @returns 锚点ID
 */
export const generateAnchorId = (text: string): string => {
  // 检查是否包含 "Part" 并提取数字
  const partMatch = text.match(/Part\s*(\d+)/i);
  if (partMatch) {
    const partNumber = partMatch[1];
    const restText = text.replace(/Part\s*\d+\.\s*/i, '').trim();
    return `part-${partNumber}-${toSlug(restText)}`;
  }

  // 如果不包含 "Part"，直接使用 toSlug
  return toSlug(text);
};
